{
  "EMOJI": {
    "PLACEHOLDER": "Iskanje emojijev",
    "NOT_FOUND": "Z vašim iskanjem se ne ujema noben emoji",
    "REMOVE": "Odstrani"
  }
}
